// Generated by Melange

import * as Buhta_models__Atd from "../../../../packages/models/Atd.js";
import * as Buhta_models__Protocol_v1_mel from "../../../../packages/models/generated/Protocol_v1_mel.js";

function decode(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_v1_mel.read_crm_ticket_action, param);
}

const Action = {
  decode: decode
};

function decode$1(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_v1_mel.read_crm_ticket, param);
}

function decodeDetailed(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_v1_mel.read_crm_ticket_detailed, param);
}

function grid(param) {
  return Buhta_models__Atd.Grid_wrap.decode(decode$1, param);
}

const Ticket = {
  Action: Action,
  decode: decode$1,
  decodeDetailed: decodeDetailed,
  grid: grid
};

function decode$2(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_v1_mel.read_crm_org_summary, param);
}

const OrgSummary = {
  decode: decode$2
};

function decode$3(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_v1_mel.read_crm_filter_org, param);
}

function grid$1(param) {
  return Buhta_models__Atd.Grid_wrap.decode(decode$3, param);
}

const Org = {
  decode: decode$3,
  grid: grid$1
};

export {
  Ticket,
  OrgSummary,
  Org,
}
/* Buhta_models__Atd Not a pure module */
